<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('configurations.link_status')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRef">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.status')}}</label>
              <el-form-item prop="tagNombre">
                <base-el-select ref="statusesSelect" class="w-full" :options="statuses" v-model="form.statusesSelected" multiple filterable :disabled="isLoadingSelect" @visible-change="onExpand" @change="onChangeInput" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button mode="secondary-phantom-blue"
        class="w-full"
        v-if="!isAllSelected" 
        :disabled="isLoadingSelect || isEmptyList" 
        :text="$t('app.select_all')" 
        @click="$refs.statusesSelect.selectAll()" 
        :loading="isLoadingSelect"
        />
      <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
        class="w-full"
        @click="$refs.statusesSelect.unselectAll()"
        :loading="isLoadingSelect"
        :disabled="isLoadingSelect || isEmptyList"
        />
        <div class="w-48 "></div>
      <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
        class="w-full"
        :loading="isLoadingSelect"
        :disabled="isLoadingSelect"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="apply" 
        :loading="isLoadingSelect"
        :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'

export default
{
  name: 'user-link-status-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [Number, String],
      default: -1
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        statusesSelected: []
      },
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
  },
  computed: {
    statuses: function () {
      return [...this.$store.getters['config/TIPOS_ESTADO'], ...this.$store.getters['config/TIPOS_ESTADO_RECEPCION'], ...this.$store.getters['config/TIPOS_ESTADO_VERIFACTU']]
    },
    isEmptyList: function () {
      return this.statuses === undefined || this.statuses === null || this.statuses.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.statuses.length === this.form.statusesSelected.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.statusesSelected = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.statusesSelected)
      this.form.statusesSelected = []
    },
  }
}
</script>

<style lang="scss" scoped></style>
